<template>
  <div class="app-container">
    <basic-container>
      <avue-crud
        :data="data"
        :option="spaceshipListOption"
        :summary-method="summaryMethod"
        @refresh-change="loadData"
        :table-loading="loading">
        <template slot="menuLeft">
           当前阶段为：{{status}}
        </template>
        <template slot="boostedValue" slot-scope="scope">
           {{scope.row.boostedValue}}%
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>

import { spaceshipListOption } from '@/const/crud/manager-contest/spaceship';
import { fetchSpaceshipList } from '@/api/manager-contest/manager-contest';

export default {
  data() {
    return {
      spaceshipListOption,
      data: [],
      status: "",
      loading: false,
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.status = "";
      this.loading = true;
      fetchSpaceshipList().then(response => {
        if (response.data && response.data.code === 0 && response.data.data) {
          this.data = response.data.data.spaceshipStatsList;
          this.status = response.data.data.status;
        }
        this.loading = false;
      });
      this.loading = false;
    },
    summaryMethod({ columns, data }){
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          if ([2,3].includes(index)){
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          } else {
            const total = Number(sums[2]);
            const boost = Number(sums[3]);
            if (isNaN(total) || total === 0){
              sums[index] = 0 + '%';
              return;
            }
            sums[index] = ((boost / total) *100 ).toFixed(2) + '%';
          }
        }
      });
      return sums;
    },
  }
}

</script>

<style lang="scss" scoped>

</style>
